/* global ga */

const projectCategory = 'interactive'; // mandatory - 'interactif or interactif'
const projectName = 'crise'; // mandatory - name of project
const projectType = 'website'; // mandatory - Website || App || instalation
const pageViewString = `/${projectCategory}/${projectName}/${projectType}`;

// let counter = 0;
// let timer_count = 0;

const sendPageView = (action) => {
    if (typeof ga !== 'undefined') {
        try {
            ga('onfglobal.send', 'pageview', pageViewString);
            ga('onfproject.send', 'pageview', pageViewString);
            // console.log('analytics pageview', pageViewString);
        } catch (e) {
            console.log('analytics pageview error', e);
        }
    }
}

const sendEvent = (category, action) => {
    if (typeof ga !== 'undefined') {
        try {
            ga('onfglobal.send', {
                hitType: 'event',          // Required.
                eventCategory: category,   // Required.
                eventAction: action,      // Required
                eventLabel: `${projectName}_website`,
            });
            ga('onfproject.send', {
                hitType: 'event',          // Required.
                eventCategory: category,   // Required.
                eventAction: action,      // Required.
                eventLabel: `${projectName}_website`,
            });
            // console.log('analytics event', category, action);
        } catch (e) {
            console.log('analytics event arror', e);
        }
    }
 }

 export default sendPageView;

 export {
     sendPageView,
     sendEvent,
 };



// WEBPACK FOOTER //
// ./js/lib/analytics.js